import React, {useEffect, useState} from "react";
import homeaboutimg from '../assets/images/homeaboutimg.webp';
import gallry2 from '../assets/images/alumniassociatinimg.webp';
import gallry3 from '../assets/images/aboutbanner.webp';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import 'aos/dist/aos.css';
import LightGallery from 'lightgallery/react';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

// Styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';

const Gallery = () => {

    const [showloading, setshowloding] = useState(false);
    const [fetcheddata, setfetcheddata] = useState([]);
      const navigate = useNavigate();

      const fetchcommiteedata = async() => {
        setshowloding(true);
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          let resp = await axios
          .get(apiUrl + "getusersgallery", headers)
          .then((res) => {
            if (res.data.status == "success" && res?.data?.data?.length > 0) {
                setfetcheddata(res?.data?.data)
                setshowloding(false);
            } else {
                setfetcheddata([])
                setshowloding(false);
            }
          })
          setshowloding(false);
  
    }

    useEffect(() => {
                              AOS.init();
                              AOS.refresh();
                              fetchcommiteedata();
                          }, [])

    return (
        <div>
            <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Gallery</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                        Gallery</p>
                </div>
            </section>

            <section className="gallery-section">
                <div className="container">

                    <p className="home-about-head text-center">Looks Inside About Gallery</p>

                    
                    {
        fetcheddata?.length > 0 ?
        <LightGallery
  speed={500}
  plugins={[lgThumbnail, lgZoom]}
>
{/* <div className="row"> */}
    {fetcheddata?.map((item, index) => {
          return (
            <>
                <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4 gallery-img-div" key={index} href={assetsUrl + 'gallery/' + item.image}>
              <img src={assetsUrl+'gallery/'+item.image} className="gallery-img" />
            </div>
            </>
            
          );
        })}
        {/* </div> */}
</LightGallery>
         : 
        showloading ?
        <div>
             <Spinner color='#264790' size={22} className='spinnerCenter' />
        </div>
        :
        <p className="alumini-comitee-member-name" style={{textAlign: 'center'}}>No events added</p>
      }
                      
                </div>

            </section>
        </div>
    )
}
export default Gallery